import { z } from 'zod'
import type { SorterParams } from '@/types/schema/api/sorter-params-schema'
import tokenBasedPaginationSchema, {
  type TokenBasedPagination,
} from '@/types/schema/api/token-based-pagination'
import {
  directoryCustomizedSearchLeafFieldSchema,
  directoryKolSchema,
} from '@/types/schema/directory/kol-management'

export const kolCollectionKolSchema = directoryKolSchema
  .omit({ kol_management_status: true })
  .extend({
    collection_kol_id: z.string().nullable(),
    collection_customized_fields: directoryCustomizedSearchLeafFieldSchema
      .omit({
        visible: true,
        sortable: true,
      })
      .extend({ value: z.string().nullable() })
      .array(),
  })
export type KolCollectionKol = z.infer<typeof kolCollectionKolSchema>

export const fetchKolCollectionKolsResponseSchema = z.object({
  data: tokenBasedPaginationSchema.extend({
    kols: kolCollectionKolSchema.array(),
  }),
})
export type FetchKolCollectionKolsResponse = z.infer<
  typeof fetchKolCollectionKolsResponseSchema
>

export const fetchKolCollectionSimpleKolsResponseSchema = z.object({
  data: tokenBasedPaginationSchema.extend({
    kols: kolCollectionKolSchema
      .pick({
        kol_uuid: true,
        names: true,
        is_lock: true,
        is_verified: true,
        is_radar_star: true,
        potential: true,
        collection_kol_id: true,
        links: true,
        follow_count: true,
      })
      .extend({
        hash_kol_datahub_identity_id: z.string(),
        is_added_to_directory: z.boolean(),
      })
      .array(),
  }),
})
export type FetchKolCollectionSimpleKolsResponse = z.infer<
  typeof fetchKolCollectionSimpleKolsResponseSchema
>

export interface FetchKolCollectionKolsRequest
  extends Omit<TokenBasedPagination, 'total' | 'total_page'>,
    SorterParams {
  id: number
}
export interface FetchKolCollectionSimpleKolsRequest
  extends Omit<TokenBasedPagination, 'total' | 'total_page'>,
    SorterParams {
  id: number
  kol_uuids?: string[]
}
